import * as React from 'react';

import { Collapse, CardHeader, CardBody, Card } from 'reactstrap';


import ExcelJS from 'exceljs';
import { Panel, PanelBody, PanelHeader } from '../../header/panel/panel';
import { ExpandMore } from '@mui/icons-material';
import { ExpandLess } from '@material-ui/icons';




export default function CollapsibleTable(props) {

    const [open, setOpen] = React.useState();

    const handleToggle = (key) => {
        setOpen(open === key ? null : key);
    };


    const handleExport = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Settlement Data');

        // Define custom headers
        worksheet.columns = [
            {
                header: 'Transaction Date',
                width: 30

            },
            {
                header: 'Daily Total Settlement',
                width: 30

            },
            {
                header: 'Deposite Date',
                width: 30

            },
            {
                header: 'Deposite Amount',
                width: 30

            },
            {
                header: 'Bank Statement Descriptor',
                width: 30

            }
            // 'Daily Total Settlement', 'Deposite Date', 'Deposite Amount', 'Bank Statement Descriptor'
        ];

        // Add headers to the worksheet
        // worksheet.addRow(headers);
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).alignment = { horizontal: 'center' };
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f5f5f5' },
        };

        let rowIndex = 2; // Start from the second row for data

        worksheet.getColumn(1).numFmt = 'YYYY-MM-DD';
        worksheet.getColumn(2).numFmt = '"$"#,##0.00';
        worksheet.getColumn(3).numFmt = 'YYYY-MM-DD';
        worksheet.getColumn(4).numFmt = '"$"#,##0.00';



        const data = props.data;
        // Iterate over the dailySettlementSummary to populate data
        for (const summary of data.dailySettlementSummary) {

            // Iterate through each settlement detail and populate rows
            for (const detail of summary.settlementDetails) {
                const row = [
                    '', '',  // Empty for merged cells
                    detail.settleDate,
                    detail.dailySettlementAmount,
                    detail.bankstmtDescriptor,
                ];
                const addRow = worksheet.addRow(row);
                addRow.alignment = { horizontal: 'center', vertical: 'middle' };

                worksheet.getCell(`A${rowIndex}`).value = summary?.transactionDate;
                worksheet.getCell(`B${rowIndex}`).value = summary?.dailyTotalSettlementAmount;

                rowIndex++;  // Increment rowIndex for next entry
            }


            // Merge transactionDate and dailyTotalSettlementAmount cells for each summary
            //   worksheet.mergeCells(`A${rowIndex - summary.settlementDetails.length}:A${rowIndex  - 1}`);
            worksheet.mergeCells(`B${rowIndex - summary.settlementDetails.length}:B${rowIndex - 1}`);

            // Fill in the values for merged cells
            //   worksheet.getCell(`A${rowIndex- summary.settlementDetails.length}`).value = summary.transactionDate;
            //   worksheet.getCell(`B${rowIndex- summary.settlementDetails.length}`).value = summary.dailyTotalSettlementAmount;

        }

        worksheet.autoFilter = { from: 'A1', to: 'E1' };

        // Save the file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        console.log('Row number : ' + rowIndex)
        const filename = 'Deposit Report ' + data.merchantName + ' ' + worksheet.getRow(2).getCell(1) + ' To ' + worksheet.getRow(rowIndex - 1).getCell(1)
        link.download = filename + '.xlsx';
        link.click();
    };


    return (


        <Panel>

            <PanelHeader>

                <div className="row mb-0">

                    <div className="col-xl-10">
                        <h4>Settlement Report</h4>
                    </div>
                    <div className="col-xl-2">
                        <button className="btn btn-sm btn-primary d-block w-40 btn-lg h-30px fs-09px" onClick={handleExport}>Download</button>
                    </div>

                </div>

            </PanelHeader>

            <PanelBody>

                <div className="table-responsive">
                    <table className="table table-sm mb-0">

                        <thead>
                            <tr>
                                <th colSpan="2"><h5>Merchant - {props.data?.merchantName?.toUpperCase()}</h5>
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    TRANSACTION DATE
                                </th>
                                <th >
                                    DAILY SETTLEMENT AMOUNT
                                </th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr >
                                <td colspan="2">
                                    <div className="table-responsive">
                                        <table className="table table-sm mb-0">
                                            <div id="accordion" className="accordion rounded-top overflow-hidden">

                                                {props.data?.dailySettlementSummary?.map((row) => (

                                                    <Card key={row.transactionDate}>
                                                        <CardHeader className={(!row.collapse ? 'collapsed ' : '')} onClick={() => handleToggle(row?.transactionDate)}>
                                                            <tr onClick={() => handleToggle(row?.transactionDate)}>
                                                                <td width="600px"><b>{row?.transactionDate}</b></td>
                                                                <td width="350px"><b>{"$ " + row?.dailyTotalSettlementAmount}</b></td>
                                                                <td>
                                                                    {open === row?.transactionDate ? <ExpandLess /> : <ExpandMore />}
                                                                </td>
                                                            </tr>

                                                        </CardHeader>
                                                        <Collapse isOpen={open === row.transactionDate}>
                                                            <CardBody>
                                                                <table className="table table-sm mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th />
                                                                            <th>
                                                                                        DEPOSIT DATE
                                                                            </th>
                                                                            <th>
                                                                                        DEPOSIT SPLIT
                                                                            </th>
                                                                            <th>
                                                                                        DEPOSIT STATEMENT DESCRIPTOR
                                                                            </th>
                                                                            <th />
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {row?.settlementDetails?.map((row) => (
                                                                            <tr onClick={() => setOpen(!open)} sx={{ height: 0 }} key={row.settleDate}>
                                                                                <td />
                                                                                <td>{row.settleDate}</td>
                                                                                <td>$ {row.dailySettlementAmount}</td>
                                                                                <td>{row.bankstmtDescriptor}</td>
                                                                                <td />

                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                ))
                                                }
                                            </div>


                                        </table>
                                    </div>

                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </PanelBody>
        </Panel>


    );
}